import React, { useState, useContext } from "react";
import axios from "../api/axios";
import {
  Box,
  Button,
  TextField,
  Typography,
  Container,
  Paper,
  Alert,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const username = location.state?.username || "";

  const [form, setForm] = useState({
    username,
    oldPassword: "",
    newPassword: "",
  });
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const { user, setUser } = useContext(AuthContext);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    try {
      await axios.post("/users/change-password", {
        oldPassword: form.oldPassword,
        newPassword: form.newPassword,
      });
      setMessage("Password reset successful! Please log in.");
      setUser({ ...user, mustChangePassword: false });
      navigate("/login");
    } catch (err) {
      console.log(err);
      setError(err.response?.data?.msg || "Reset failed");
    }
  };

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ p: 4, mt: 8 }}>
        <Typography variant="h5" gutterBottom>
          Reset Password
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Old Password"
            name="oldPassword"
            value={form.oldPassword}
            onChange={handleChange}
            type="password"
            fullWidth
            margin="normal"
            required
          />
          <TextField
            label="New Password"
            name="newPassword"
            value={form.newPassword}
            onChange={handleChange}
            type="password"
            fullWidth
            margin="normal"
            required
          />
          {error && <Alert severity="error">{error}</Alert>}
          {message && <Alert severity="success">{message}</Alert>}
          <Box mt={2}>
            <Button type="submit" variant="contained" fullWidth>
              Reset Password
            </Button>
            <Button
              onClick={() => navigate(-1)}
              variant="outlined"
              fullWidth
              sx={{ my: 1 }}
            >
              Go Back
            </Button>
          </Box>
        </form>
      </Paper>
    </Container>
  );
};

export default ResetPassword;
